import { render, staticRenderFns } from "./ball2.vue?vue&type=template&id=7ef6fba1&scoped=true&"
var script = {}
import style0 from "./ball2.vue?vue&type=style&index=0&id=7ef6fba1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef6fba1",
  null
  
)

export default component.exports